import img_0 from '../images/img_0.png';

export default {
  v: '5.7.4',
  fr: 25,
  ip: 33,
  op: 76,
  w: 1435,
  h: 283,
  nm: 'Pre-comp 16',
  ddd: 0,
  assets: [
    { id: 'image_0', w: 4066, h: 764, u: '', p: img_0, e: 0 },
    {
      id: 'comp_0',
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 2,
          nm: 'tape.png',
          cl: 'png',
          refId: 'image_0',
          sr: 1,
          ks: { p: { a: 0, k: [2662.5, 1799.5, 0] }, a: { a: 0, k: [2033, 382, 0] } },
          ao: 0,
          ip: 0,
          op: 750,
          st: 0,
          bm: 0,
        },
      ],
    },
  ],
  layers: [
    {
      ddd: 0,
      ind: 10,
      ty: 3,
      nm: 'Pre-comp 14',
      sr: 1,
      ks: { p: { a: 0, k: [763.5, 136.6, 0] }, a: { a: 0, k: [800, 195, 0] } },
      ao: 0,
      ip: 0,
      op: 750,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 11,
      ty: 0,
      nm: 'shutterstock_1419611699 Precomp',
      parent: 10,
      td: 1,
      refId: 'comp_0',
      sr: 1,
      ks: {
        p: { a: 0, k: [727.5, 175.4, 0] },
        a: { a: 0, k: [2592, 1728, 0] },
        s: { a: 0, k: [35.173, 37.023, 100] },
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: 'a',
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0.33, y: 1 },
                o: { x: 0.67, y: 0 },
                t: 28,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [587.775, 1343.067],
                      [555.81, 1343.208],
                      [555.81, 2241.056],
                      [587.775, 2240.915],
                    ],
                    c: true,
                  },
                ],
              },
              {
                t: 75,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [4767.143, 1343.208],
                      [555.81, 1343.208],
                      [555.81, 2241.056],
                      [4767.143, 2241.056],
                    ],
                    c: true,
                  },
                ],
              },
            ],
          },
          o: { a: 0, k: 100 },
          x: { a: 0, k: 0 },
          nm: 'Mask 1',
        },
      ],
      ef: [
        {
          ty: 5,
          nm: 'Color Range',
          np: 11,
          mn: 'ADBE Color Range',
          ix: 1,
          en: 1,
          ef: [
            { ty: 6, nm: 'Preview', mn: 'ADBE Color Range-0001', ix: 1, v: 0 },
            { ty: 0, nm: 'Fuzziness', mn: 'ADBE Color Range-0002', ix: 2, v: { a: 0, k: 0 } },
            { ty: 7, nm: 'Color Space', mn: 'ADBE Color Range-0003', ix: 3, v: { a: 0, k: 1 } },
            { ty: 0, nm: 'Min (L, Y, R)', mn: 'ADBE Color Range-0004', ix: 4, v: { a: 0, k: 255 } },
            { ty: 0, nm: 'Max (L, Y, R)', mn: 'ADBE Color Range-0005', ix: 5, v: { a: 0, k: 255 } },
            { ty: 0, nm: 'Min (a, U, G)', mn: 'ADBE Color Range-0006', ix: 6, v: { a: 0, k: 128 } },
            { ty: 0, nm: 'Max (a, U, G)', mn: 'ADBE Color Range-0007', ix: 7, v: { a: 0, k: 128 } },
            { ty: 0, nm: 'Min (b, V, B)', mn: 'ADBE Color Range-0008', ix: 8, v: { a: 0, k: 128 } },
            { ty: 0, nm: 'Max (b, V, B)', mn: 'ADBE Color Range-0009', ix: 9, v: { a: 0, k: 128 } },
          ],
        },
        {
          ty: 5,
          nm: 'Simple Choker',
          np: 4,
          mn: 'ADBE Simple Choker',
          ix: 2,
          en: 1,
          ef: [
            { ty: 7, nm: 'View', mn: 'ADBE Simple Choker-0001', ix: 1, v: { a: 0, k: 1 } },
            { ty: 0, nm: 'Choke Matte', mn: 'ADBE Simple Choker-0002', ix: 2, v: { a: 0, k: 12 } },
          ],
        },
        {
          ty: 5,
          nm: 'Hue/Saturation',
          np: 11,
          mn: 'ADBE HUE SATURATION',
          ix: 3,
          en: 1,
          ef: [
            {
              ty: 7,
              nm: 'Channel Control',
              mn: 'ADBE HUE SATURATION-0002',
              ix: 1,
              v: { a: 0, k: 1 },
            },
            {},
            { ty: 0, nm: 'Master Hue', mn: 'ADBE HUE SATURATION-0004', ix: 3, v: { a: 0, k: 16 } },
            {
              ty: 0,
              nm: 'Master Saturation',
              mn: 'ADBE HUE SATURATION-0005',
              ix: 4,
              v: { a: 0, k: 0 },
            },
            {
              ty: 0,
              nm: 'Master Lightness',
              mn: 'ADBE HUE SATURATION-0006',
              ix: 5,
              v: { a: 0, k: 11 },
            },
            { ty: 7, nm: 'Colorize', mn: 'ADBE HUE SATURATION-0007', ix: 6, v: { a: 0, k: 0 } },
            { ty: 0, nm: 'Colorize Hue', mn: 'ADBE HUE SATURATION-0008', ix: 7, v: { a: 0, k: 0 } },
            {
              ty: 0,
              nm: 'Colorize Saturation',
              mn: 'ADBE HUE SATURATION-0009',
              ix: 8,
              v: { a: 0, k: 25 },
            },
            {
              ty: 0,
              nm: 'Colorize Lightness',
              mn: 'ADBE HUE SATURATION-0010',
              ix: 9,
              v: { a: 0, k: 0 },
            },
          ],
        },
      ],
      w: 5184,
      h: 3456,
      ip: 0,
      op: 750,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 12,
      ty: 4,
      nm: 'Shape Layer 2',
      parent: 10,
      tt: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 51 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.33, y: 1 },
              o: { x: 0.67, y: 0 },
              t: 28,
              s: [113.5, 457.9, 0],
              to: [245, 0, 0],
              ti: [-245, 0, 0],
            },
            { t: 75, s: [1583.5, 457.9, 0] },
          ],
        },
        s: { a: 0, k: [100, 121.861, 100] },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ty: 'rc',
              d: 1,
              s: { a: 0, k: [90, 234] },
              p: { a: 0, k: [0, 0] },
              r: { a: 0, k: 0 },
              nm: 'Rectangle Path 1',
              hd: false,
            },
            {
              ty: 'st',
              c: { a: 0, k: [1, 1, 1, 1] },
              o: { a: 0, k: 100 },
              w: { a: 0, k: 0 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: 'Stroke 1',
              hd: false,
            },
            {
              ty: 'gf',
              o: { a: 0, k: 100 },
              r: 1,
              bm: 0,
              g: {
                p: 5,
                k: {
                  a: 0,
                  k: [
                    0,
                    0,
                    0,
                    0,
                    0.189,
                    0.5,
                    0.5,
                    0.5,
                    0.25,
                    1,
                    1,
                    1,
                    0.444,
                    0.5,
                    0.5,
                    0.5,
                    1,
                    0,
                    0,
                    0,
                  ],
                },
              },
              s: { a: 0, k: [38, 0] },
              e: { a: 0, k: [-39, 0] },
              t: 1,
              nm: 'Gradient Fill 1',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [-136, -221.5] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 117.431] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: 'Transform',
            },
          ],
          nm: 'Rectangle 1',
          bm: 0,
          hd: false,
        },
      ],
      ip: 0,
      op: 750,
      st: 0,
      bm: 2,
    },
    {
      ddd: 0,
      ind: 13,
      ty: 0,
      nm: 'shutterstock_1419611699 Precomp',
      parent: 10,
      td: 1,
      refId: 'comp_0',
      sr: 1,
      ks: {
        p: { a: 0, k: [727.5, 175.4, 0] },
        a: { a: 0, k: [2592, 1728, 0] },
        s: { a: 0, k: [35.173, 37.023, 100] },
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: 'a',
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0.33, y: 1 },
                o: { x: 0.67, y: 0 },
                t: 28,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [587.775, 1343.067],
                      [555.81, 1343.208],
                      [555.81, 2241.056],
                      [587.775, 2240.915],
                    ],
                    c: true,
                  },
                ],
              },
              {
                t: 75,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [4767.143, 1343.208],
                      [555.81, 1343.208],
                      [555.81, 2241.056],
                      [4767.143, 2241.056],
                    ],
                    c: true,
                  },
                ],
              },
            ],
          },
          o: { a: 0, k: 100 },
          x: { a: 0, k: 0 },
          nm: 'Mask 1',
        },
      ],
      ef: [
        {
          ty: 5,
          nm: 'Color Range',
          np: 11,
          mn: 'ADBE Color Range',
          ix: 1,
          en: 1,
          ef: [
            { ty: 6, nm: 'Preview', mn: 'ADBE Color Range-0001', ix: 1, v: 0 },
            { ty: 0, nm: 'Fuzziness', mn: 'ADBE Color Range-0002', ix: 2, v: { a: 0, k: 0 } },
            { ty: 7, nm: 'Color Space', mn: 'ADBE Color Range-0003', ix: 3, v: { a: 0, k: 1 } },
            { ty: 0, nm: 'Min (L, Y, R)', mn: 'ADBE Color Range-0004', ix: 4, v: { a: 0, k: 255 } },
            { ty: 0, nm: 'Max (L, Y, R)', mn: 'ADBE Color Range-0005', ix: 5, v: { a: 0, k: 255 } },
            { ty: 0, nm: 'Min (a, U, G)', mn: 'ADBE Color Range-0006', ix: 6, v: { a: 0, k: 128 } },
            { ty: 0, nm: 'Max (a, U, G)', mn: 'ADBE Color Range-0007', ix: 7, v: { a: 0, k: 128 } },
            { ty: 0, nm: 'Min (b, V, B)', mn: 'ADBE Color Range-0008', ix: 8, v: { a: 0, k: 128 } },
            { ty: 0, nm: 'Max (b, V, B)', mn: 'ADBE Color Range-0009', ix: 9, v: { a: 0, k: 128 } },
          ],
        },
        {
          ty: 5,
          nm: 'Simple Choker',
          np: 4,
          mn: 'ADBE Simple Choker',
          ix: 2,
          en: 1,
          ef: [
            { ty: 7, nm: 'View', mn: 'ADBE Simple Choker-0001', ix: 1, v: { a: 0, k: 1 } },
            { ty: 0, nm: 'Choke Matte', mn: 'ADBE Simple Choker-0002', ix: 2, v: { a: 0, k: 12 } },
          ],
        },
        {
          ty: 5,
          nm: 'Hue/Saturation',
          np: 11,
          mn: 'ADBE HUE SATURATION',
          ix: 3,
          en: 1,
          ef: [
            {
              ty: 7,
              nm: 'Channel Control',
              mn: 'ADBE HUE SATURATION-0002',
              ix: 1,
              v: { a: 0, k: 1 },
            },
            {},
            { ty: 0, nm: 'Master Hue', mn: 'ADBE HUE SATURATION-0004', ix: 3, v: { a: 0, k: 16 } },
            {
              ty: 0,
              nm: 'Master Saturation',
              mn: 'ADBE HUE SATURATION-0005',
              ix: 4,
              v: { a: 0, k: 0 },
            },
            {
              ty: 0,
              nm: 'Master Lightness',
              mn: 'ADBE HUE SATURATION-0006',
              ix: 5,
              v: { a: 0, k: 11 },
            },
            { ty: 7, nm: 'Colorize', mn: 'ADBE HUE SATURATION-0007', ix: 6, v: { a: 0, k: 0 } },
            { ty: 0, nm: 'Colorize Hue', mn: 'ADBE HUE SATURATION-0008', ix: 7, v: { a: 0, k: 0 } },
            {
              ty: 0,
              nm: 'Colorize Saturation',
              mn: 'ADBE HUE SATURATION-0009',
              ix: 8,
              v: { a: 0, k: 25 },
            },
            {
              ty: 0,
              nm: 'Colorize Lightness',
              mn: 'ADBE HUE SATURATION-0010',
              ix: 9,
              v: { a: 0, k: 0 },
            },
          ],
        },
      ],
      w: 5184,
      h: 3456,
      ip: 0,
      op: 750,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 14,
      ty: 4,
      nm: 'Shape Layer 1',
      parent: 10,
      tt: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 74 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.33, y: 1 },
              o: { x: 0.67, y: 0 },
              t: 28,
              s: [113.5, 457.9, 0],
              to: [245, 0, 0],
              ti: [-245, 0, 0],
            },
            { t: 75, s: [1583.5, 457.9, 0] },
          ],
        },
        a: { a: 0, k: [0, -60, 0] },
        s: { a: 0, k: [100, 153.823, 100] },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ty: 'rc',
              d: 1,
              s: { a: 0, k: [90, 234] },
              p: { a: 0, k: [0, 0] },
              r: { a: 0, k: 0 },
              nm: 'Rectangle Path 1',
              hd: false,
            },
            {
              ty: 'st',
              c: { a: 0, k: [1, 1, 1, 1] },
              o: { a: 0, k: 100 },
              w: { a: 0, k: 0 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: 'Stroke 1',
              hd: false,
            },
            {
              ty: 'gf',
              o: { a: 0, k: 100 },
              r: 1,
              bm: 0,
              g: {
                p: 3,
                k: { a: 0, k: [0, 0.467, 0.467, 0.467, 0.25, 0.733, 0.733, 0.733, 1, 1, 1, 1] },
              },
              s: { a: 0, k: [38, 0] },
              e: { a: 0, k: [-39, 0] },
              t: 1,
              nm: 'Gradient Fill 1',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [-136, -221.5] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: 'Transform',
            },
          ],
          nm: 'Rectangle 1',
          bm: 0,
          hd: false,
        },
      ],
      ip: 0,
      op: 750,
      st: 0,
      bm: 1,
    },
    {
      ddd: 0,
      ind: 15,
      ty: 0,
      nm: 'shutterstock_1419611699 Precomp',
      parent: 10,
      refId: 'comp_0',
      sr: 1,
      ks: {
        p: { a: 0, k: [727.5, 175.4, 0] },
        a: { a: 0, k: [2592, 1728, 0] },
        s: { a: 0, k: [35.173, 37.023, 100] },
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: 'a',
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0.33, y: 1 },
                o: { x: 0.67, y: 0 },
                t: 28,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [587.775, 1343.067],
                      [555.81, 1343.208],
                      [555.81, 2241.056],
                      [587.775, 2240.915],
                    ],
                    c: true,
                  },
                ],
              },
              {
                t: 75,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [4767.143, 1343.208],
                      [555.81, 1343.208],
                      [555.81, 2241.056],
                      [4767.143, 2241.056],
                    ],
                    c: true,
                  },
                ],
              },
            ],
          },
          o: { a: 0, k: 100 },
          x: { a: 0, k: 0 },
          nm: 'Mask 1',
        },
      ],
      w: 5184,
      h: 3456,
      ip: 0,
      op: 750,
      st: 0,
      bm: 0,
    },
  ],
  markers: [],
};
